// This file is auto-generated by dibs-icons script
import { FC } from 'react';
import Check20 from './Check20';
import Check20Circle from './Check20Circle';
import Check24 from './Check24';
import Check24Circle from './Check24Circle';
import Check40 from './Check40';
import Check48 from './Check48';

type CheckProps = {
    variation: '20' | '20Circle' | '24' | '24Circle' | '40' | '48';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Check20,
    Check20Circle,
    Check24,
    Check24Circle,
    Check40,
    Check48,
};

const Check: FC<CheckProps> = ({ variation, ...props }) => {
    const variationKey = `Check${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Check" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Check;
